module.exports = __webpack_public_path__ + "animoji2.6557f5339d.png";